import script from "./StatoIdrosat.vue?vue&type=script&setup=true&lang=js"
export * from "./StatoIdrosat.vue?vue&type=script&setup=true&lang=js"

import "./StatoIdrosat.vue?vue&type=style&index=0&id=3d31b7ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d31b7ee"]])

export default __exports__